const PIXEL_ID = '1744921309871699'

let initialized = false
let pixelModule: typeof import('react-facebook-pixel') | null = null

const loadPixel = async () => {
  if (pixelModule) return pixelModule
  try {
    const mod = await import('react-facebook-pixel')
    pixelModule = mod
    return mod
  } catch (err) {
    console.warn('[MetaPixel] failed to load library', err)
    return null
  }
}

const ensureInit = async () => {
  if (initialized || typeof window === 'undefined') return pixelModule
  // Make sure the DOM has at least one <script> tag so the FB snippet
  // (which calls document.getElementsByTagName('script')[0].parentNode) doesn't blow up.
  if (!document.getElementsByTagName('script').length) {
    try {
      document.head.appendChild(document.createElement('script'))
    } catch {
      /* noop */
    }
  }
  const mod = await loadPixel()
  if (!mod) return null
  try {
    mod.default.init(PIXEL_ID, undefined, {
      autoConfig: true,
      debug: false,
    })
    initialized = true
  } catch (err) {
    console.warn('[MetaPixel] init failed', err)
    return null
  }
  return mod
}

const safeTrack = (eventName: string, data?: Record<string, unknown>) => {
  if (typeof window === 'undefined') return
  // Defer to next tick so DOM is settled before FB snippet runs.
  setTimeout(async () => {
    try {
      const mod = await ensureInit()
      if (!mod) return
      if (eventName === 'PageView') {
        mod.default.pageView()
      } else {
        mod.default.track(eventName, data)
      }
    } catch (err) {
      console.warn('[MetaPixel] track failed', eventName, err)
    }
  }, 0)
}

export const trackPageView = () => safeTrack('PageView')
export const trackAddToCart = (data?: Record<string, unknown>) =>
  safeTrack('AddToCart', data)
export const trackInitiateCheckout = (data?: Record<string, unknown>) =>
  safeTrack('InitiateCheckout', data)
